import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useLocation } from "react-router-dom";
import { SocketContext } from "../../../../utils/serviceContext";
import * as slideBoxActions from "../../actions/slidebox-action";
import _ from "lodash";
import { ProgressBar } from "react-bootstrap";
import CloseIcon from "../../../../assets/icons/close-new.svg";

class ProgressBarComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openSnackBar: props.open,
      uploadFileList: props.fileList,
      isConverting: {},
      isConverted: {},
      uploadProgress: {},
      expanding: true,
    };

    this.uploadSucess = {};
    this.onFileUploadDoneSubscriber = undefined;
    this.onFileUploadProgressSubscriber = undefined;
  }

  static contextType = SocketContext;

  componentDidUpdate(prevProps) {
    if (!_.isEmpty(this.props.conversionComplete) &&
        this.props.conversionComplete !== prevProps.conversionComplete) {
      this.setState({
        isConverting: {
          ...this.state.isConverting,
          [this.props.conversionComplete.name]: true,
        },
      });
    }

    if (this.props.fileList && prevProps.fileList &&
        this.props.fileList !== prevProps.fileList) {
      this.setState({
        uploadFileList: [...this.props.fileList],
      });

      const remaining = this.props.fileList.filter((f) => f);

      if (remaining.length > 0 && remaining.every((f) => f.progress === 100)) {
        this.props.closeCallBack("Uploaded", true);
      }
    }
  }

  componentDidMount() {
    const socketReady = this.context && typeof this.context.socket === 'object' && typeof this.context.socket.on === 'function';
    if (!socketReady) return;

    try {
      this.onFileUploadDoneSubscriber = this.context
        .onFileUploadDone()
        .subscribe((data) => {
          const { closeCallBack, location } = this.props;

          setTimeout(() => {
            // Drop just the file that finished, instead of waiting for every
            // file in the batch to reach 100% before anything leaves the list —
            // otherwise a fast small file sits on "Finishing..." until a much
            // slower file in the same batch (e.g. a large TIFF) also completes.
            const doneIndex = this.state.uploadFileList.findIndex(
              (f) => f && f.name === data.fileName
            );
            if (doneIndex !== -1) {
              this.props.removeUploadingFile(doneIndex);
            }

            const anyRemaining = this.state.uploadFileList.some(
              (f, i) => f && i !== doneIndex
            );
            if (!anyRemaining) {
              closeCallBack("Uploaded", true);

              if (location && location.pathname === "/slidebox") {
                this.props.fetchSlideBoxFolders();
              }
            }
          }, 1000);
        });

      this.onFileUploadProgressSubscriber = this.context
        .onFileUploadProgress()
        .subscribe((data) => {
          if (data.progress === 100) {
            setTimeout(() => {
              this.uploadSucess[data.name] = true;
            }, 300);
          }

          this.setState({
            uploadProgress: {
              ...this.state.uploadProgress,
              [data.name]:
                data && data.progress ? data.progress : 0,
            },
          });
        });
    } catch (e) {
      // socket not initialized in this environment
    }
  }

  componentWillUnmount() {
    if (this.onFileUploadDoneSubscriber) {
      this.onFileUploadDoneSubscriber.unsubscribe();
    }

    if (this.onFileUploadProgressSubscriber) {
      this.onFileUploadProgressSubscriber.unsubscribe();
    }
  }

  onToggleExpand = () => {
    this.setState({
      expanding: !this.state.expanding,
    });
  };

  onStopUploading = (fileIndex = -1) => {
    const file = this.state.uploadFileList[fileIndex];

    if (!file) return;

    file.canceller && file.canceller();

    this.props.removeUploadingFile(fileIndex);
  };

  render() {
    const { closeCallBack } = this.props;
    const { uploadFileList, expanding } = this.state;

    return (
      <div className="progress-bar-container">
        <ProgressBarHeader
          fileCount={
            uploadFileList
              ? uploadFileList.filter((file) => file).length
              : 0
          }
          onClose={closeCallBack}
          expanding={expanding}
          onToggleExpand={this.onToggleExpand}
          style={{
            backgroundColor: "#ffffff",
            color: "#0f0da1",
            fontFamily: "Roboto, sans-serif",
          }}
        />

        <div
          className="progress-content"
          style={{
            display: expanding ? "inherit" : "none",
          }}
        >
          {uploadFileList.map((fileData, i) => {
            if (fileData)
              return (
                <div className="progress-item" key={i}>
                  <span>{fileData.name}</span>

                  <ProgressBar
                    variant="success"
                    now={fileData.progress}
                    label={
                      fileData.progress !== 100
                        ? `${
                            typeof fileData.progress ===
                            "undefined"
                              ? 0
                              : fileData.progress
                          }%`
                        : "Finishing..."
                    }
                  />

                  <span className="progress-speed">
                    {fileData.speed}
                  </span>

                  <div
                    className="progress-item-close"
                    onClick={() =>
                      this.onStopUploading(i)
                    }
                  >
                    <img src={CloseIcon} alt="" />
                  </div>
                </div>
              );
          })}
        </div>
      </div>
    );
  }
}

const ProgressBarHeader = ({
  fileCount,
  onClose,
  expanding,
  onToggleExpand,
}) => {
  return (
    <div className="progress-bar-header">
      <h3>{`Uploading ${fileCount} File...`}</h3>

      <div
        className="expand-progress"
        onClick={onToggleExpand}
      >
        <i
          className={
            expanding
              ? "fas fa-chevron-down"
              : "fas fa-chevron-up"
          }
        />
      </div>

      <div className="close-progress" onClick={() => onClose()}>
        <img src={CloseIcon} alt="close" />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...slideBoxActions }, dispatch);

const ProgressBarComponentWithRouter = (props) => {
  const location = useLocation();

  return (
    <ProgressBarComponent
      {...props}
      location={location}
    />
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProgressBarComponentWithRouter);